module.exports = __webpack_public_path__ + "assets/img/08.a2248610.png";